import { render, staticRenderFns } from "./SearchProductForm.vue?vue&type=template&id=50249613&"
import script from "./SearchProductForm.vue?vue&type=script&lang=ts&"
export * from "./SearchProductForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports